import { createContext, useContext, useState } from 'react';

const HotelLangSelectionContext = createContext(null);

export function HotelLangSelectionProvider({ children }) {
  const [selectedHotels, setSelectedHotels] = useState([]);
  const [selectedLanguages, setSelectedLanguages] = useState([]);

  const onSave = (type, allDocuments, allLabels, updateLegalTextMassiveFn) => {
    selectedHotels.forEach(hotel => {
      selectedLanguages.forEach(lang => {
        const doc = allDocuments.find(doc => doc.type === type && doc.lang === lang.code);
        const label = allLabels.find(
          label => label.type === `${type}-label` && label.lang === lang.code
        );
        if (!doc) return;
        updateLegalTextMassiveFn(
          type,
          doc.value,
          label?.value || '',
          false,
          true,
          hotel.hotelId,
          lang.code,
          false
        );
      });
    });
  };

  return (
    <HotelLangSelectionContext.Provider
      value={{
        selectedHotels,
        setSelectedHotels,
        selectedLanguages,
        setSelectedLanguages,
        onSave,
      }}
    >
      {children}
    </HotelLangSelectionContext.Provider>
  );
}

export function useHotelLangSelection() {
  return useContext(HotelLangSelectionContext);
}
